import gql from 'graphql-tag';

export default gql`
    mutation($organizationId: String!, $addressId: String!, $isArchived: Boolean!) {
        markAddressArchived (organizationId: $organizationId, addressId: $addressId, isArchived: $isArchived)
    }
`;